import React from 'react';
import { Grid } from '@mui/material';
import UserRolesList from './UserRolesList';
import InviteUserForm from './InviteUserForm';

const UsersAndRoles = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <UserRolesList />
      </Grid>
      <Grid item xs={12} md={4}>
        <InviteUserForm />
      </Grid>
    </Grid>
  );
};

export default UsersAndRoles;
